<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

interface Props {
  messages?: string[]
}

const { messages } = defineProps<Props>();
const messageIndex = ref(0);
let interval: ReturnType<typeof setInterval>;

onMounted(() => {
  if (messages) {
    interval = setInterval(() => {
      const nextMessageIndex = messageIndex.value + 1;
      const messagesLength = messages.length - 1;

      messageIndex.value = nextMessageIndex > messagesLength ? 0 : nextMessageIndex;
    }, 2000);
  }
});

onUnmounted(() => {
  clearInterval(interval);
});
</script>

<template>
  <div class="loader-wrapper flex flex-col justify-center">
    <span class="spinner" />
    <span v-if="messages" class="message">{{ messages[messageIndex] }}</span>
  </div>
</template>

<style scoped lang="scss">
.loader-wrapper {
  margin-bottom: 20px;
  width: 50px;

  .spinner {
    width: auto;
    height: 50px;
    background: rgba(#fff, 0.9) url(/public/spinner.gif) no-repeat center center;
  }

  .message {
    text-align: center;
    color: #333;
  }
}
</style>
